import { queryOptions, skipToken } from '@tanstack/react-query';

import type { SalesOrderRefundPreview } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

type RefundPreviewParams = {
  url: string | null;
};

export const salesOrderKeys = {
  all: () => ['salesOrders'] as const,
  refundPreview: (props: RefundPreviewParams) =>
    [...salesOrderKeys.all(), 'refundPreview', props.url] as const,
};

export const salesOrderQueries = {
  refundPreview: (props: RefundPreviewParams) => {
    const { url } = props;

    return queryOptions({
      queryKey: salesOrderKeys.refundPreview(props),
      queryFn: url
        ? () =>
            HttpClient.request<SalesOrderRefundPreview>({ method: 'GET', url })
        : skipToken,
      refetchOnWindowFocus: false,
    });
  },
};
